import defaultUser from '../utils/default-user';
import axios from '../utils/axiosConfig'
import Swal from 'sweetalert2'

interface LoginCredentials {
  username: string;
  password: string;
}

interface UserResponse {
  success: boolean;
  message: string;
  token: string;
  data: {
    id: string;
    nama: string;
    email: string;
  };
}

export const login = async (credentials: LoginCredentials): Promise<UserResponse> => {
  try {
    const response = await axios.post<UserResponse>("/auth/login", credentials);
    return response.data;
  } catch (error: any) {
    console.error("Login API Error:", error.response || error.message);
    throw new Error(
      error.response?.data?.message || "Failed to login, please try again."
    );
  }
};

export async function signIn(email: string, password: string) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true,
      data: defaultUser
    };
  }
  catch {
    return {
      isOk: false,
      message: "Authentication failed"
    };
  }
}

export async function getUser() {
  try {
    // Send request

    return {
      isOk: true,
      data: defaultUser
    };
  }
  catch {
    return {
      isOk: false
    };
  }
}

export async function createAccount(email: string, password: string) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    // Send request
    // console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email: string) {
  try {
    // Send request
    // console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
